import React from 'react';

import { Button, Group, Modal, Stack, Text, Title } from '@mantine/core';
import useDeleteAppointmentCoachRole from 'hooks/appointmentCoachRole/useDeleteAppointmentCoachRole';
import notificationHandler from 'utils/notifications';

interface IModalDeleteAppointmentCoachRole {
  opened: boolean;
  handleClose: () => void;
  appointmentCoachRoleId?: string;
}

const ModalDeleteAppointmentCoachRole = ({
  opened,
  appointmentCoachRoleId,
  handleClose,
}: IModalDeleteAppointmentCoachRole): JSX.Element => {
  const deleteMutation = useDeleteAppointmentCoachRole();

  const { successNotification, errorNotification } = notificationHandler();
  const handleDelete = (): void => {
    if (appointmentCoachRoleId) {
      deleteMutation.mutate(appointmentCoachRoleId, {
        onSuccess: () => {
          successNotification('Coach role for appointment delete success', `Role successfully deleted.`);
          handleClose();
        },
        onError: error => {
          errorNotification('Coach role for appointment delete failed', error.response?.data.message);
        },
      });
    }
  };
  return (
    <Modal
      centered
      opened={opened}
      onClose={handleClose}
      title={<Title order={4}>Delete Coach Role For Appointments</Title>}
      zIndex={201}
      size='auto'
    >
      <Stack>
        <Text>Are you sure you want to delete this role?</Text>
        <Text color='dimmed'>
          This action cannot be undone. It will delete this coach role for all other coaches.
        </Text>
        <Group position='right'>
          <Button
            onClick={handleDelete}
            color='red'
            loading={deleteMutation.isLoading}
            data-cy='submitDeleteAppointmentCoachRoleButton'
          >
            Submit
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default ModalDeleteAppointmentCoachRole;
